// removed by extract-text-webpack-plugin
module.exports = {"Header":"src-components-Header-__Header-module___Header","controls":"src-components-Header-__Header-module___controls"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.css
// module id = 670
// module chunks = 0